import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Row, Col } from 'react-bootstrap';
import ValidationTable from './ValidationTable';
import EditUsuarioSpreadModal from './EditUsuarioSpreadModal';

// Estilos para el modal de fondo
const modalBackgroundStyle = `
  .modal-background .modal-content {
    opacity: 0.3;
    pointer-events: none;
    filter: blur(2px);
  }
  .modal-background .modal-backdrop {
    background-color: rgba(0, 0, 0, 0.8) !important;
  }
`;

// Inyectar estilos si no existen
if (!document.getElementById('modal-background-styles')) {
  const styleSheet = document.createElement('style');
  styleSheet.id = 'modal-background-styles';
  styleSheet.textContent = modalBackgroundStyle;
  document.head.appendChild(styleSheet);
}

const ValidationModal = ({
  show,
  onHide,
  validationData,
  validationTotal,
  validationLoading,
  validationPageNumber,
  validationPageSize,
  validationSearchValue,
  onSearchChange,
  onPageChange,
  onPageSizeChange,
  // Modal de edición
  showEditModal,
  selectedUsuarioSpread,
  onEditUsuarioSpread,
  onCloseEditModal,
  // Datos para edición
  conductores,
  empresas,
  tiposFlota,
  centrosDespacho,
  sistemasTMS,
  tiposDocumento,
  generalesLoading,
  onAssignUsuarioMovil,
  onCreateConductorUsuarioMovil
}) => {
  const totalPages = Math.max(1, Math.ceil(validationTotal / validationPageSize));

  return (
    <>
      <Modal 
        show={show} 
        onHide={onHide} 
        size="xl" 
        backdrop="static"
        className={showEditModal ? 'modal-background' : ''}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Conductores con Datos Faltantes
            {validationTotal > 0 && (
              <span className="badge bg-danger ms-2">{validationTotal}</span>
            )}
          </Modal.Title>
        </Modal.Header>
        
        <Modal.Body>
          {/* Búsqueda */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Búsqueda</Form.Label>
                <Form.Control
                  type="text"
                  value={validationSearchValue}
                  onChange={e => onSearchChange(e.target.value)}
                  placeholder="Buscar usuario (mínimo 5 caracteres)"
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Tabla de validaciones */}
          <ValidationTable
            validationData={validationData}
            onEditClick={onEditUsuarioSpread}
            pageIndex={validationPageNumber - 1}
            pageCount={totalPages}
            onPageChange={page => onPageChange(page + 1)}
            pageSize={validationPageSize}
            onPageSizeChange={onPageSizeChange}
            total={validationTotal}
            loading={validationLoading}
          />
        </Modal.Body>
      </Modal>

      {/* Modal de edición */}
      <EditUsuarioSpreadModal
        show={showEditModal}
        onHide={onCloseEditModal}
        usuarioSpread={selectedUsuarioSpread}
        conductores={conductores}
        empresas={empresas}
        tiposFlota={tiposFlota}
        centrosDespacho={centrosDespacho}
        sistemasTMS={sistemasTMS}
        tiposDocumento={tiposDocumento}
        onAssign={onAssignUsuarioMovil}
        onCreateConductor={onCreateConductorUsuarioMovil}
        loading={generalesLoading}
      />
    </>
  );
};

ValidationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  validationData: PropTypes.array.isRequired,
  validationTotal: PropTypes.number.isRequired,
  validationLoading: PropTypes.bool.isRequired,
  validationPageNumber: PropTypes.number.isRequired,
  validationPageSize: PropTypes.number.isRequired,
  validationSearchValue: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  // Modal de edición
  showEditModal: PropTypes.bool.isRequired,
  selectedUsuarioSpread: PropTypes.object,
  onEditUsuarioSpread: PropTypes.func.isRequired,
  onCloseEditModal: PropTypes.func.isRequired,
  // Datos para edición
  conductores: PropTypes.array.isRequired,
  empresas: PropTypes.array.isRequired,
  tiposFlota: PropTypes.array.isRequired,
  centrosDespacho: PropTypes.array.isRequired,
  sistemasTMS: PropTypes.array.isRequired,
  tiposDocumento: PropTypes.array.isRequired,
  generalesLoading: PropTypes.bool.isRequired,
  onAssignUsuarioMovil: PropTypes.func.isRequired,
  onCreateConductorUsuarioMovil: PropTypes.func.isRequired
};

export default ValidationModal;
